import React, { useState } from 'react';
import { updateStorageObject } from '@/utils/global';
import { Mixpanel } from '@/utils/mixpanel';
import { surveyForm1V2Validation } from '@/utils/validationSchema';

import { useFormValidation } from '@/hooks/useFormValidation';
import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import RightArrow from '@/components/Icons/icons/RightArrow';

import { useSurveyContext } from '../surveyContext';

const SurveyPage1V2 = () => {
  const { setSurveyFormStep, form1V2Data, setForm1V2Data } = useSurveyContext();

  const {
    errors,
    setErrors,
    validate,
  }: { errors: any; setErrors: React.Dispatch<React.SetStateAction<{}>>; validate: any } =
    useFormValidation(surveyForm1V2Validation);

  const onFormSubmit = async (e: { preventDefault: () => void }) => {
    e?.preventDefault();
    const isValid = validate(form1V2Data);
    if (!isValid) return;
    Mixpanel.track('onboarding_step_completed', {
      'Step Name': 'First Step',
      'Step Number': 1,
      Responses: form1V2Data,
    });
    updateStorageObject('onboarding-form-data', 'form1V2', form1V2Data);
    //@ts-ignore
    setSurveyFormStep(6);
  };

  return (
    <form onSubmit={onFormSubmit}>
      <div className="survey-v2-1-container">
        <div className="survey-1-content">
          <div className="survey-1-form">
            <div className="survey-1-textarea-container">
              <div className="survey-1-form-text-area-label">What will make this a win for you?</div>
              <textarea
                value={form1V2Data.winForBrand}
                onChange={(e) => {
                  setErrors((e) => ({ ...e, winForBrand: null }));
                  //@ts-ignore
                  setForm1V2Data((p: any) => ({ ...p, winForBrand: e.target.value }));
                }}
                rows={6}
                className="survey-1-form-text-area"
                placeholder="If we're talking in 3-6 months and you're very happy with SARAL. What has happened? Describe your ideal business outcomes."
              />
              {errors?.winForBrand && <div className="survey-error-text">{errors?.winForBrand}</div>}
            </div>
            <div className="survey-1-textarea-container">
              <div className="survey-1-form-text-area-label">
                What are your biggest questions or roadblocks to get there?
              </div>
              <textarea
                value={form1V2Data.roadblocks}
                onChange={(e) => {
                  setErrors((e) => ({ ...e, roadblocks: null }));
                  //@ts-ignore
                  setForm1V2Data((p: any) => ({ ...p, roadblocks: e.target.value }));
                }}
                draggable={false}
                rows={6}
                className="survey-1-form-text-area"
                placeholder="What questions do you have for us about influencer strategy or the tool which  we can help answer in our upcoming meeting?"
              />
              {errors.roadblocks && <div className="survey-error-text">{errors.roadblocks}</div>}
            </div>
            <div className="survey-1-bottom-container pt-2">
              <ButtonComponent style={{ flex: 2 }} type="submit">
                Next <RightArrow color="#fff" />
              </ButtonComponent>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SurveyPage1V2;
